import { useMemo } from 'react';
import { SeoDefaultContextValue } from '@funtech-int/yango-shared';
import { Head, useI18n as useI18nManager } from '@funtech-int/rival-react';

import { useRuntimeConfig } from '@/shared/hooks/useRuntimeConfig';
import { clientConfig } from '@/config/client';

import { FaviconLinks } from '../components/FaviconLinks/FaviconLinks';

const { brandName, defaultMeta } = clientConfig;

export const useSeoDefaultValue = (): SeoDefaultContextValue => {
    const { locales } = useI18nManager();
    const runtimeConfig = useRuntimeConfig();
    const { lang } = useI18nManager().locale.get();

    return useMemo(
        () => ({
            Head,
            FaviconLinks,
            hostOrigin: runtimeConfig.get('host'),
            currentLang: lang,
            locales: locales.map((locale) => locale.lang),

            seoSiteName: brandName.replace(/\u00a0/gi, ' '),
            seoImage: {
                url: defaultMeta.ogImageUrl,
                width: defaultMeta.ogImageWidth,
                height: defaultMeta.ogImageHeight,
            },
        }),
        [runtimeConfig, lang, locales]
    );
};
